import { BasicSelect, MultiSelect } from 'vue-search-select'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import CryptoJS from 'crypto-js'
import Pagination from './../../../../shared/components/pagination'
import CustomExpandableTable from './../../../../shared/components/customExpandableTable'
import Loader from '../../../../shared/components/loader'
import CONSTANT from './../../../../shared/constants/constant'
// import Util from './../../../../shared/util'
import Treeselect from '@riophae/vue-treeselect'
import TripServices from './../../../services/firstAndLastmilemanagement.service'
import ClientService from './../../../../clientmanagement/services/clientmanagement.service'
import CreateRouteMapping from './CreateRouteMapping';
import MasterService from './../../../../masterdata/services/masterdata.service'
import XLSX from 'xlsx'

const moment = require('moment')

export default {
  name: 'RouteMapping',
  components: {
    Treeselect,
    CryptoJS,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    Loader,
    CreateRouteMapping,
    Multiselect,
  },
  data: function () {
    return {
      createFTCCashDeposit: false,
      isLoading: false,
      companyNamelist: [],
      tableColumn: [      
        "Route ID",
        "Route Name",
        "BA",
        "Created By",
        "Status",
        "Action",
      ],
      tableItems: [],
      tableData:[],
      boxtypelist: [],
      totalPage: 0,
      currentPage: 1,
      total: 0,
      totalCount: 0,
      perPage: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      offset: 0,
      AWB: "",
      Action: "",
      showCreateRouteMapping:false,
      useremail: "",
      Clientlist:[],
      parentData:{},
      selectedClient: null,
      selectedClient: null,
      tempRouteidList:[],
      AssignedSR: null,
      AssignedList: [],
      routeIdSearch:[],
      RouteIdList:[],
      createdByList:[],
      selectedCreatedBy:null,
      RouteIdInput:'',
      tableDataforRoutename:[],
      tableDataforRouteidandname:[],
      username:"",
      hubnamelist:[],
      hubname:'',
    };
  },
  computed: {},
  async mounted () {
    var userdetailEncrypt = window.localStorage.getItem(
      'cargoAutoaccessuserdata'
    )
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
    var plaintext = bytes.toString(CryptoJS.enc.Utf8)
    var userdetail = JSON.parse(plaintext)
    this.userdetail = userdetail;
    this.userRoleFlag = (userdetail.rolename[0] == "Admin" || userdetail.rolename[0] == "Cargo Controlling Tower") ? 1:2;
    this.username=userdetail.email;
    this.hubid = userdetail.hubID[0];
    this.localuserid = userdetail.userid;
    this.useremail = userdetail.email
    this.isLoading = true;
    this.isLoading = false;
    this.getRouteListing();
    this.getCreatedByListing();
    this.getSRListing();
    this.Search();
    this.getHubList();
  },
  methods: {
    async updatestatus(input) {
      try {
        let payload = {
          id : input.id,
        }
        payload.lastmodifiedby = this.username
        if (input.actionType == 'active') {
          payload.status = 0
        } else if (input.actionType == 'inactive') {
          payload.status = 1
        }
        let result = await TripServices.changeRouteMappingStatus(payload);
        if(result.data.code == 200) {
          let message = input.actionType == 'inactive' ? "Route Mapping Activated": "Route Mapping Inactivated";
          this.actionType == 'active'
          this.$alert(message, "", "success");
        } else{
          this.$alert(result.data.message, "", "error");
        }
        this.reset()
      } catch (error) {
        this.$alert("Route mapping already Active/Inactive.", "", "error");
      }
    },
    async getSRListing() {
      try {
        let InputPayload = {
          HubId: [this.hubid]
        };
        let result = await TripServices.getSRList(InputPayload);
        if(result.data.code == 200) {
        let SRList = result.data.data;
        for (var i = 0; i < SRList.length; i++) {
          this.AssignedList.push({
            'usertype':SRList[i].emptype,
            'id': SRList[i].userid,
            'label': SRList[i].srname ,
          });
        }
      } else{
        this.$alert(result.data.message, "", "error");
      }
      } catch (err) {
        console.log(err);
      }
    },
    async getRouteListing() {
      try {
        this.isLoading=true;
        let InputPayload = {
          HubId: [this.hubid]
        };
        let result = await TripServices.getRouteList(InputPayload);
        if(result.data.code == 200) {
        let RouteIdList = result.data.data;
        for (var i = 0; i < RouteIdList.length; i++) {
          this.RouteIdList.push({
            'id': RouteIdList[i].id,
            'label': RouteIdList[i].routename ,
          });
        }
      } else{
        this.$alert(result.data.message, "", "error");
      }
      this.isLoading=false;
      } catch (err) {
        this.isLoading=false;
        console.log(err);
      }
    },
    async getCreatedByListing() {
      try {
        this.isLoading=true;
        let InputPayload = {
          HubId: [this.hubid]
        };
        let result = await TripServices.getCreatedByListiForRouteMapping(InputPayload);
        if(result.data.code == 200) {
        this.createdByList=result.data.data;
      } else{
        this.$alert(result.data.message, "", "error");
      }
      this.isLoading=false;
      } catch (err) {
        this.isLoading=false;
        console.log(err);
      }
    },
    onPageChange(page){
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.Search();
    },
    routeMappingConfiguration(type,data, selectedData) {
      this.showCreateRouteMapping = true;
      this.parentData = {
        action: type,
        AssignedSR: this.AssignedSR,
        RouteName:[],
        useremail:this.useremail
      }
      if (type== 'update') {
        this.parentData.AssignedSR = this.routeMappingingObj
        this.parentData.RouteName=this.tableDataforRouteidandname
        this.parentData.hubID= selectedData[0].hubid;
        this.tableDataforRouteidandname=[];
      }
    },
    getCustomTableEvent(event) {
      if (event.actionType == 'edit') {
        this.isLoading = true;
        let routeMappingingObj  = this.tableData.filter(function(Items) {
          return Items.id == event.id;
        });
        this.routeMappingingObj = routeMappingingObj[0];
        let routeMappingingObjnames  = this.tableDataforRoutename.filter(function(Items) {
          return Items.id == event.id;
        });
        this.routeMappingingObjnames = routeMappingingObjnames[0];
        let len=this.routeMappingingObjnames.routeid.length;
        for(let k=0;k<len;k++)
        {
          this.tableDataforRouteidandname.push({
            "id":this.routeMappingingObjnames.routeid[k],
            "label":this.routeMappingingObjnames.routename[k]
          })
        }
        this.routeMappingingObjnames=[]
        this.routeMappingConfiguration('update', event, routeMappingingObj)
        this.isLoading = false;
      } else {
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
          this.updatestatus(event);
        }).catch((err)=>{
          console.log(err)
        });
      }
    },
    callParent(data) {
      this.Search();
      this.showCreateRouteMapping = false;
      this.parentData = {}
    },
    async Search(){
      try {
        this.tableDataforRoutename=[]
        this.tableItems=[]
        let temparr=[]
        this.isLoading = true;
        let inputPayload = {
        "offset": this.offset,
        "limit": this.pageLimit,
        "hubid":this.hubid,
        }
        if(this.routeIdSearch.id){
        inputPayload.routeid = [this.routeIdSearch.id];
        }
        if(this.RouteIdInput){
          inputPayload.routeid=[this.RouteIdInput]
          }
        if(this.selectedCreatedBy){
        inputPayload.createdby = this.selectedCreatedBy.createdby;
        }
        if(this.AssignedSR){
        inputPayload.userid = this.AssignedSR.id;
        }
        let result = await TripServices.getRouteMappingList(inputPayload);
        if(result.data.code == 200) {
        result.data.data.rows.forEach(el => {
          temparr.push({id:el.routeid})
        });
        this.totalCount =result.data.data.count;
        for(let i=0;i<temparr.length;i++)
        {
          let routeNameResult=await TripServices.getRouteNameByRouteId(temparr[i]);
          this.tableData = result.data.data.rows;
          this.tableDataforRoutename.push({
            "id":result.data.data.rows[i].id,
            "routeid":result.data.data.rows[i].routeid,
            "routename":routeNameResult.data
          })
          let routeidsarray=result.data.data.rows[i].routeid;
            this.tableItems.push({
              "id":result.data.data.rows[i].id,
              "BA":result.data.data.rows[i].username,
              "Route ID":(result.data.data.rows[i].routeid).join(),
              "Route Name":(routeNameResult.data).join(),
              "Created By":result.data.data.rows[i].createdby,
              "Status":result.data.data.rows[i].status,
               "Action":null
            });
        }
      } else{
        this.$alert(result.data.message, "", "error");
      }
        this.isLoading = false;
        if (this.totalCount < this.pageLimit) {
        this.totalPage = 1
        } else {
        this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
      },
    reset() {
      this.selectedCreatedBy = null
      this.AssignedSR = null;
      this.routeIdSearch = [];
      this.tableItems=[];
      this.RouteIdInput='';
      this.hubname= '';
      this.Search();
    },
    async getHubList() {
      try {
        this.isLoading = true;
        let input = {}
        let tempArr = [];
        if (this.userRoleFlag == 1) {
          let result = await TripServices.GetHublist(input);
          let HubList = result.data.data.data;
          for (var i = 0; i < HubList.length; i++) {
            tempArr.push({
              'value': HubList[i].HubID,
              'text': HubList[i].HubName
            });
          }
        } else {
          tempArr.push({
            'value': this.defaultHubID,
            'text': this.userdetail.currentHubName
          })
        }
        this.isLoading = false;
        this.hubnamelist = tempArr
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    selectHub(event) {
      this.hubid = event.value;
      this.createdByList=[];
      this.AssignedList=[];
      this.getCreatedByListing();
      this.getSRListing();
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/Autoallocation/RouteMapping/RouteMapping.component.js